export default "__VITE_ASSET__Cxye2cya__"